import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useGetTopSkillPathData } from '../hooks/useSkillPathData';
import Loading from '../components/Loading/Loading';

const AdminMenu = () => {

  const [skillPathsTop, loading, err1, err2] = useGetTopSkillPathData();
  const URLId = useParams();

   /* #region Classes */
  const setActiveButton = (skillPathId:number) => {
    const linkClasses = ['btn-outlined-primary', 'wht-spc-no-wrap'];
    if(URLId.id){
      let intId = parseInt(URLId.id);
      if(intId === skillPathId){
        linkClasses.push('active');
      }
    }
    return linkClasses.join(' ');
  }
  /* #endregion Classes */
  
  if (skillPathsTop === true || skillPathsTop === false || skillPathsTop == null) return <Loading isLoading={true} />

  return <fieldset aria-labelledby='framework-selector-heading' className='max-width m-t-2 bg-white thick-border rounded'>
    <legend className="on-admin clr-primary">
      <h2 id="framework-selector-heading" className='p-l--50 p-r--50 fnt-wght-700 ltr-spcng-normal m-b-0 m-t-0 h3-size'>Select the framework you would like to update</h2>
    </legend>
    <ul className='reset dis-flex dis-flex-jst-center dis-flex-rows gap--50'>
      
        {skillPathsTop && skillPathsTop.length > 0 &&
          skillPathsTop.map((item: any, index: number) => (
            <li key={item.skillPathId + index}>
            <Link className={setActiveButton(item.skillPathId)} to={`/admin/editskillpath/${item.skillPathId}`} >{item.skillPathName}</Link>
            </li>
          ))}
      
    </ul>

  </fieldset>;
};

export default AdminMenu;